// src/hooks/useWatchlist.js
import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import apiClient from "../api/apiClient";
import { useToast } from "@chakra-ui/react";

export default function useWatchlist(navigate) {
  const { user, logout, addTickerToWatchlist, removeTickerFromWatchlist } = useAuth();
  const [watchlist, setWatchlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await apiClient.get("/watchlist");
        setWatchlist(res.data || []);
      } catch (err) {
        if (err.response?.status === 401) {
          logout();
          navigate("/login");
        }
        console.error("Watchlist load error:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [logout, navigate]);

  const addTicker = async (ticker) => {
    try {
      await addTickerToWatchlist([ticker]);
      setWatchlist((prev) => [...prev, ticker]);
      toast({
        title: `${ticker} added to watchlist.`,
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: "Add failed",
        description: err.response?.data?.error || err.message || "Could not add ticker",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const removeTicker = async (ticker) => {
    try {
      await removeTickerFromWatchlist(ticker);
      setWatchlist((prev) => prev.filter((t) => t !== ticker));
    } catch (err) {
      toast({
        title: "Remove failed",
        description: err.response?.data?.error || "Could not remove ticker",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return { watchlist, loading, addTicker, removeTicker };
}
